export enum AuthRoles {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_ATC = 'ROLE_ATC',
}
